<template lang="pug">
span.copy(@click.stop='copy' :title='`複製文字至剪貼簿`' :class='textClass')
  span(ref='a')
    slot
  v-snackbar(v-model='isShow' :timeout='1000' v-if='text' style='z-index: 10000')
    span #[v-icon.mr-2(small color='white') fas fa-clipboard]
      span.primary--text.target-text {{ text }}
      span  已複製
</template>

<script>
import copyToClipboard from 'copy-to-clipboard'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      isShow: false, // 是否顯示複製成功 snackbar
      text: '',
    }
  },
  methods: {
    copy () {
      const ref = this.$refs.a
      const text = this.value || ref.innerText || ref.textContent

      this.text = text
      this.$nextTick(() => { this.isShow = true }) // 懶加載，避免建立太多元素

      copyToClipboard(text)
    },
  },
  computed: {
    textClass () {
      return {
      }
    },
  },
}
</script>

<style scoped lang="sass">
// 能提供複製功能的文字
.copy
  display: inline-block
  border-bottom: 1px dotted transparent
  &:hover
    border-bottom-color: grey
    cursor: pointer

.target-text
  &::before, &::after
    content: "\""
</style>
